<template>
  <div class="tw-flex tw-items-center tw-gap-1.5">
    <button
      v-if="allowTimeToggling"
      type="button"
      :disabled="isDisabled"
      v-tippy="{ content: isTimeEnabled ? 'Time enabled — click to use date only' : 'Date only — click to add a time', placement: 'bottom' }"
      class="tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-border tw-transition-colors disabled:tw-opacity-40 disabled:tw-cursor-not-allowed"
      :class="isTimeEnabled
        ? 'tw-border-indigo-200 tw-bg-indigo-50 tw-text-indigo-600 hover:tw-bg-indigo-100'
        : 'tw-border-slate-200 tw-bg-white tw-text-slate-400 hover:tw-bg-slate-50'"
      @click="$emit('toggleTime')"
    >
      <span class="tw-relative tw-inline-flex tw-items-center tw-justify-center" :class="{ 'time-disabled-slash': !isTimeEnabled }">
        <font-awesome-icon icon="clock" class="tw-h-3.5 tw-w-3.5" />
      </span>
    </button>

    <template v-if="showDaysShortcuts">
      <button
        type="button"
        :disabled="isDisabled"
        v-tippy="{ content: 'Today', placement: 'bottom' }"
        class="tw-inline-flex tw-h-7 tw-items-center tw-gap-1 tw-rounded-full tw-border tw-border-slate-200 tw-bg-white tw-px-2.5 tw-text-xs tw-text-slate-600 tw-transition-colors hover:tw-bg-slate-50 disabled:tw-opacity-40 disabled:tw-cursor-not-allowed"
        @click="$emit('setToday')"
      >
        <font-awesome-icon icon="calendar-day" class="tw-h-3 tw-w-3" />
        today
      </button>
      <button
        type="button"
        :disabled="isDisabled"
        v-tippy="{ content: 'One day earlier', placement: 'bottom' }"
        class="tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white tw-text-slate-600 tw-transition-colors hover:tw-bg-slate-50 disabled:tw-opacity-40 disabled:tw-cursor-not-allowed"
        @click="$emit('shiftDays', -1)"
      >
        <font-awesome-icon icon="minus" class="tw-h-3 tw-w-3" />
      </button>
      <button
        type="button"
        :disabled="isDisabled"
        v-tippy="{ content: 'One day later', placement: 'bottom' }"
        class="tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white tw-text-slate-600 tw-transition-colors hover:tw-bg-slate-50 disabled:tw-opacity-40 disabled:tw-cursor-not-allowed"
        @click="$emit('shiftDays', 1)"
      >
        <font-awesome-icon icon="plus" class="tw-h-3 tw-w-3" />
      </button>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DateTimePickerControls',
  props: {
    allowTimeToggling: {
      type: Boolean,
      default: false,
    },
    showDaysShortcuts: {
      type: Boolean,
      default: false,
    },
    isTimeEnabled: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggleTime', 'setToday', 'shiftDays'],
});
</script>

<style lang="scss" scoped>
/* free-solid FontAwesome has no clock-slash icon, so draw the slash ourselves */
.time-disabled-slash::after {
  content: '';
  position: absolute;
  left: -1px;
  right: -1px;
  top: 50%;
  border-top: 1.5px solid currentColor;
  transform: rotate(-45deg);
}
</style>
